import { Form, Space } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { EditGrayIcon, EditIcon } from 'assets/svg';
import { ButtonAction } from 'components';
import TableComponent from 'components/Table/TableComponent';
import usePagination from 'hooks/usePagination';
import { IApproval, IApprovalTable } from 'interfaces/Approval';
import { ColumnsTypeCustom } from 'interfaces/Table/ColumnType';
import Content from 'layouts/Content';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import path from 'routes/Path';
import { formatDate } from 'utils/constants/functions';
import { HocChangePagination } from 'utils/HocChangePagination';

interface TableSetApprovalProps {
  data: IApprovalTable;
  isPending?: boolean;
}

const TableSetApproval = ({
  data,
  isPending = false,
}: TableSetApprovalProps) => {
  const [form] = useForm();
  const [editIndex] = useState(-1);
  const { page, page_size } = usePagination();
  const navigate = useNavigate();

  const handleEdit = (record: IApproval) => {
    navigate(path.APPROVAL_DETAIL, {
      state: {
        approvalId: record.id,
        name: record.name,
      },
    });
  };

  const columns: ColumnsTypeCustom = [
    {
      width: 50,
      title: 'STT',
      render: (_, __, index) => index + 1 + page_size * (page - 1),
    },
    {
      width: 200,
      title: 'Tên loại phê duyệt',
      dataIndex: 'name',
    },
    {
      width: 160,
      title: 'Người cập nhật',
      dataIndex: ['tmodifyUser', 'fullName'],
    },
    {
      width: 170,
      title: 'Ngày cập nhật',
      dataIndex: 'modifyDate',
      render: (value) => (value ? formatDate(value, 'DD/MM/YYYY') : '-'),
    },
    {
      title: '',
      fixed: 'right',
      width: 100,
      align: 'center',
      render: (_, record) => {
        return (
          <Space size={'middle'} className="text-lg ">
            {/* <ButtonAction tooltip="Xem chi tiết">
              <EyeIcon /> 
            </ButtonAction> */}
            <ButtonAction
              tooltip="Chỉnh sửa"
              onClick={() => handleEdit(record)}
            >
              {editIndex == -1 ? <EditIcon /> : <EditGrayIcon />}
            </ButtonAction>
          </Space>
        );
      },
    },
  ];

  return (
    <Content>
      <Form form={form}>
        <TableComponent
          columns={columns}
          dataSource={data.items}
          pagination={{
            current: data.pageInfo?.currentPage,
            pageSize: data.pageInfo?.itemsPerPage,
            total: data.pageInfo?.totalItems,
            onChange: HocChangePagination(),
          }}
          loading={isPending}
          scroll={{
            x: 'max-content',
          }}
        />
      </Form>
    </Content>
  );
};

export default TableSetApproval;
